import React, { Component } from "react";
// import AddFileByUrlRender from "./children/AddFileByUrlRender";
import AddFileByUrlModalRender from "./children/AddFileByUrlModalRender";

class AddFileByUrlFunction extends Component {
  constructor(props) {
    super(props);
    this.state = {
      url: "",
    };
  }

  render() {
    return (
      <div className={`AddFileByUrl ${this.props.theme}`}>
        {/* <AddFileByUrlRender parseUrl={this.props.parseUrl} onUrlChange={this.props.onUrlChange} url={this.props.url} /> */}
        <AddFileByUrlModalRender visible={this.props.visible} onCancel={this.props.onCancel} url={this.props.url} />
      </div>
    );
  }
}

export default AddFileByUrlFunction;
